'use client';

import type { ReactNode } from 'react';
import { useEffect, useRef } from 'react';

import { MESSAGE_KEYWORD, useHandleApp } from '@/modules/wello-app';
import { useAuthStore } from '@/stores/AuthStore';

import { useAdGuards } from '../_hooks/useAdGuards';

interface AdpopcornProviderProps {
  children?: ReactNode;
}

export const AdpopcornProvider = ({ children }: AdpopcornProviderProps) => {
  const { isMounted, isWelloApp, isExternalWebview } = useAdGuards();
  const isReady = isMounted && isWelloApp && !isExternalWebview;

  const memberOAuth = useAuthStore((state) => state.myInfo?.memberOAuth);

  const { request } = useHandleApp({
    type: MESSAGE_KEYWORD.SET_ADPOPCORN_USER_ID,
  });

  const lastSentRef = useRef<string | null>(null);

  useEffect(() => {
    if (!isReady) {
      return;
    }

    if (!memberOAuth) {
      return;
    }

    const userId = String(memberOAuth);
    if (lastSentRef.current === userId) {
      return;
    }

    lastSentRef.current = userId;
    request({ userId });
  }, [isReady, memberOAuth, request]);

  return <>{children}</>;
};
